<template>
  <div>
    <header
      class="header "
      :class="{
        greyBg: $route.path === '/',
        header__shadow: $route.path !== '/',
      }"
    >
      <marquee behavior="" direction="left" style="color: #95ABC6">
        Sayt test rejimida ishlamoqda...Kamchiliklar uchun uzr so'raymiz
      </marquee>
      <div class="container">
        <div class="header__inner">
          <div class="header__left">
            <router-link
              to="/"
              class="logo"
              style="display: flex;align-items: center;gap: 20px"
            >
              <img
                src="https://admin.copu.uz/media/logo/photo_2023-07-09_13-26-18.jpg"
                alt="logo"
              />
              <p
                style="  font-size: 18px;
    font-weight: 700;
    line-height: 22px;
    text-align: left;
    color: #00173f"
              >
                O'zbekiston <br />
                Fiziklar <br />
                Kengashi
              </p>
            </router-link>
            <!-- <ul class="header__menu" v-if="!isDesktopMedium">
              <li
                class="header__menu-item"
                v-for="(item, index) in menu"
                :key="index"
                v-on="handleShowDropdown(item.id)"
              >
                <router-link :to="item.link" class="header__menu-link">
                  {{ item.title }}
                </router-link>

                <transition name="slide">
                  <div class="dropdown__menu" v-if="item.id === activeId">
                    <ul class="dropdown__menu-inner">
                      <li
                        class="dropdown__menu-item"
                        v-for="(submenu, idx) in item.children"
                        :key="idx"
                        v-on="handleShowDropdownInner(submenu.id)"
                      >
                        <router-link
                          to="/"
                          class="dropdown__menu-link"
                          :class="{
                            'has-dropdown': submenu && submenu.children.length,
                          }"
                        >
                          {{ submenu.title }}
                        </router-link>

                        <transition name="slide-right">
                          <div
                            class="dropdown__menu"
                            v-if="submenu.id === subActiveId"
                          >
                            <ul class="dropdown__menu-inner">
                              <li
                                class="dropdown__menu-item"
                                v-for="(children, idx) in submenu.children"
                                :key="idx"
                              >
                                <router-link
                                  :to="'/detailed-page/' + children.id"
                                  class="dropdown__menu-link"
                                >
                                  {{ children.title }}
                                </router-link>
                              </li>
                            </ul>
                          </div>
                        </transition>
                      </li>
                    </ul>
                  </div>
                </transition>
              </li>
              <li class="header__menu-item">
                <a href="https://copu.uz/" target="_blank">
                  O'zbekiston Fiziklar Kengashi
                </a>
              </li>
            </ul> -->
          </div>

          <div class="header__right">
            <div class="header__auth" v-if="!userIsLoggedOn">
              <AppButton
                theme="main"
                :font-size="isMobileSmall ? 12 : isMobile ? 14 : 16"
                :sides="isMobileSmall ? 10 : isMobile ? 20 : 30"
                class="header__login mr-10"
                v-if="!isMobileSmall"
                @click="$router.push({ path: '/sign-in' })"
                >Kirish
              </AppButton>
              <AppButton
                theme="secondary"
                @click="$router.push({ path: '/sign-up' })"
                :font-size="isMobileSmall ? 12 : isMobile ? 14 : 16"
                :sides="isMobileSmall ? 10 : isMobile ? 20 : 30"
                class="header__register"
                :class="isMobileMedium ? 'mr-10' : 'mr-20'"
                v-if="!isMobileSmall"
                >Ro'yxatdan o'tish
              </AppButton>
            </div>

            <!-- <div
              class="header__language"
              :class="isMobileMedium ? '' : 'mr-20'"
              v-if="!isMobileSmall"
              @click="languageDropdown = !languageDropdown"
              v-on-click-outside:excludedClass="hideLanguageDropdown"
            >
              <div class="header__language-icon">
                <img src="/icons/globe.svg" alt="" />
              </div>

              <transition name="slide">
                <div class="header__dropdown" v-if="languageDropdown">
                  <ul
                    class="header__dropdown-wrap bordered shadowed radius overflow"
                  >
                    <li class="header__dropdown-item">
                      <router-link to="/" class="header__dropdown-link pa-10">
                        <AppText size="14" line-height="18" weight="700">
                          Uzbek
                        </AppText>
                      </router-link>
                    </li>
                  </ul>
                </div>
              </transition>
            </div> -->

            <router-link
              to="/my-favourites"
              class="header__favourite active"
              :class="isMobileSmall ? 'mr-10' : 'mr-20'"
              v-if="userIsLoggedOn"
            >
              <span class="header__favourite-icon">
                <span class="header__favourite-notification">
                  {{ favouriteCourses.length }}
                </span>
                <svg
                  width="24"
                  height="22"
                  viewBox="0 0 24 22"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  -->
                  <path
                    d="M20.4578 3.59133C19.9691 3.08683 19.3889 2.68663 18.7503 2.41358C18.1117 2.14054 17.4272 2 16.7359 2C16.0446 2 15.3601 2.14054 14.7215 2.41358C14.0829 2.68663 13.5026 3.08683 13.0139 3.59133L11.9997 4.63785L10.9855 3.59133C9.99842 2.57276 8.6596 2.00053 7.26361 2.00053C5.86761 2.00053 4.52879 2.57276 3.54168 3.59133C2.55456 4.6099 2 5.99139 2 7.43187C2 8.87235 2.55456 10.2538 3.54168 11.2724L4.55588 12.3189L11.9997 20L19.4436 12.3189L20.4578 11.2724C20.9467 10.7681 21.3346 10.1694 21.5992 9.51045C21.8638 8.85148 22 8.14517 22 7.43187C22 6.71857 21.8638 6.01225 21.5992 5.35328C21.3346 4.69431 20.9467 4.09559 20.4578 3.59133V3.59133Z"
                    stroke="#95ABC6"
                    stroke-width="2.1"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </span>
            </router-link>

            <router-link
              to="/my-cart"
              class="header__basket active"
              :class="isMobileSmall ? 'mr-10' : 'mr-20'"
              v-if="userIsLoggedOn"
            >
              <span class="header__basket-icon">
                <span class="header__basket-notification">
                  {{ coursesOnBasket.length }}
                </span>
                <svg
                  width="21"
                  height="21"
                  viewBox="0 0 21 21"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M19 14H5C4.73478 14 4.48043 13.8946 4.29289 13.7071C4.10536 13.5196 4 13.2652 4 13C4 12.7348 4.10536 12.4804 4.29289 12.2929C4.48043 12.1054 4.73478 12 5 12H15.44C16.1087 12 16.7582 11.7767 17.2854 11.3654C17.8126 10.9542 18.1873 10.3786 18.35 9.73L20 3.24C20.0375 3.09241 20.0407 2.93821 20.0095 2.78917C19.9783 2.64013 19.9135 2.50018 19.82 2.38C19.7227 2.25673 19.5978 2.1581 19.4554 2.09208C19.3129 2.02606 19.1569 1.99452 19 2H4.76C4.55369 1.41645 4.17193 0.910998 3.66707 0.552938C3.1622 0.194879 2.55894 0.00173951 1.94 0H1C0.734784 0 0.48043 0.105357 0.292893 0.292893C0.105357 0.48043 0 0.734784 0 1C0 1.26522 0.105357 1.51957 0.292893 1.70711C0.48043 1.89464 0.734784 2 1 2H1.94C2.16843 1.99334 2.39226 2.06513 2.57421 2.20341C2.75615 2.34169 2.88525 2.53812 2.94 2.76L3 3.24L4.73 10C3.93435 10.0358 3.18551 10.3862 2.64822 10.9741C2.11093 11.5621 1.8292 12.3394 1.865 13.135C1.9008 13.9306 2.25121 14.6795 2.83914 15.2168C3.42707 15.7541 4.20435 16.0358 5 16H5.18C5.01554 16.4531 4.96269 16.9392 5.02593 17.4171C5.08917 17.895 5.26665 18.3506 5.54332 18.7454C5.81999 19.1401 6.18772 19.4624 6.61535 19.6849C7.04299 19.9074 7.51795 20.0235 8 20.0235C8.48205 20.0235 8.95701 19.9074 9.38465 19.6849C9.81228 19.4624 10.18 19.1401 10.4567 18.7454C10.7334 18.3506 10.9108 17.895 10.9741 17.4171C11.0373 16.9392 10.9845 16.4531 10.82 16H13.18C13.0155 16.4531 12.9627 16.9392 13.0259 17.4171C13.0892 17.895 13.2666 18.3506 13.5433 18.7454C13.82 19.1401 14.1877 19.4624 14.6154 19.6849C15.043 19.9074 15.5179 20.0235 16 20.0235C16.4821 20.0235 16.957 19.9074 17.3846 19.6849C17.8123 19.4624 18.18 19.1401 18.4567 18.7454C18.7334 18.3506 18.9108 17.895 18.9741 17.4171C19.0373 16.9392 18.9845 16.4531 18.82 16H19C19.2652 16 19.5196 15.8946 19.7071 15.7071C19.8946 15.5196 20 15.2652 20 15C20 14.7348 19.8946 14.4804 19.7071 14.2929C19.5196 14.1054 19.2652 14 19 14ZM17.72 4L16.41 9.24C16.3552 9.46188 16.2262 9.65831 16.0442 9.79659C15.8623 9.93487 15.6384 10.0067 15.41 10H6.78L5.28 4H17.72ZM8 18C7.80222 18 7.60888 17.9414 7.44443 17.8315C7.27998 17.7216 7.15181 17.5654 7.07612 17.3827C7.00043 17.2 6.98063 16.9989 7.01921 16.8049C7.0578 16.6109 7.15304 16.4327 7.29289 16.2929C7.43275 16.153 7.61093 16.0578 7.80491 16.0192C7.99889 15.9806 8.19996 16.0004 8.38268 16.0761C8.56541 16.1518 8.72159 16.28 8.83147 16.4444C8.94135 16.6089 9 16.8022 9 17C9 17.2652 8.89464 17.5196 8.70711 17.7071C8.51957 17.8946 8.26522 18 8 18ZM16 18C15.8022 18 15.6089 17.9414 15.4444 17.8315C15.28 17.7216 15.1518 17.5654 15.0761 17.3827C15.0004 17.2 14.9806 16.9989 15.0192 16.8049C15.0578 16.6109 15.153 16.4327 15.2929 16.2929C15.4327 16.153 15.6109 16.0578 15.8049 16.0192C15.9989 15.9806 16.2 16.0004 16.3827 16.0761C16.5654 16.1518 16.7216 16.28 16.8315 16.4444C16.9414 16.6089 17 16.8022 17 17C17 17.2652 16.8946 17.5196 16.7071 17.7071C16.5196 17.8946 16.2652 18 16 18Z"
                    fill="#95ABC6"
                  />
                </svg>
              </span>
            </router-link>

            <div
              class="header__account"
              v-if="userIsLoggedOn"
              @click="accountDropdown = !accountDropdown"
              v-on-click-outside:excludedClass="hideAccountDropdown"
            >
              <div class="header__account-photo" v-if="user && user.photo">
                <img :src="baseURL + user.photo" alt="" />
              </div>
              <div class="header__account-photo" v-else>
                <img src="/images/user-photo.jpg" alt="" />
              </div>

              <transition name="slide">
                <div class="header__dropdown" v-if="accountDropdown">
                  <ul
                    class="header__dropdown-wrap bordered shadowed radius overflow"
                  >
                    <li class="header__dropdown-item">
                      <router-link
                        to="/cabinet"
                        class="header__dropdown-link pa-10"
                      >
                        <AppText size="14" line-height="18" weight="700">
                          Mening profilim
                        </AppText>
                      </router-link>
                    </li>

                    <li class="header__dropdown-item" @click.prevent="logout">
                      <router-link to="/" class="header__dropdown-link pa-10">
                        <AppText size="14" line-height="18" weight="700">
                          Chiqish
                        </AppText>
                      </router-link>
                    </li>
                  </ul>
                </div>
              </transition>
            </div>

            <AppButton
              v-if="isDesktopMedium"
              theme="transparent"
              sides="10"
              class="hamburger__menu"
              @click="showNavigationDrawer"
            >
              <img src="/icons/hamburger.svg" alt="" />
            </AppButton>
          </div>
        </div>
      </div>
    </header>
    <transition name="slide-right">
      <NavigationDrawer
        v-if="navigationDrawer"
        @closeNavigationDrawer="closeDrawer"
      />
    </transition>

    <transition name="fade">
      <div
        class="overlay"
        v-if="navigationDrawer"
        @click="navigationDrawer = false"
      ></div>
    </transition>
  </div>
</template>

<script>
import "./header.scss";
import AppButton from "../../../shared-components/AppButton";
import NavigationDrawer from "./NavigationDrawer";
import TokenService from "../../../../service/TokenService";
import { mapActions, mapGetters, mapMutations } from "vuex";

export default {
  name: "AppHeader",
  components: { NavigationDrawer, AppButton },
  data() {
    return {
      activeId: null,
      subActiveId: null,
      menu: [
        {
          id: 1,
          title: "Yo'nalishlar",
          link: "/categories",
          submenu: false,
          children: [
            {
              id: 20,
              title: "Web development",
              link: "",
              children: [
                {
                  id: 7,
                  title: "Vue JS 3",
                  link: "",
                  classMenu: false,
                },
                {
                  id: 8,
                  title: "React",
                  link: "",
                  classMenu: false,
                },
              ],
            },
            {
              id: 21,
              title: "Economy",
              link: "",
              children: [
                {
                  id: 9,
                  title: "International Financial Reporting Standards",
                  link: "",
                },
              ],
            },
            {
              id: 22,
              title: "Natural sciences",
              link: "",
              children: [
                {
                  id: 10,
                  title: "General, inorganic chemistry",
                  link: "",
                },
              ],
            },
            {
              id: 23,
              title: "Computer graphics and design",
              link: "",
              children: [
                {
                  id: 11,
                  title: "3d Max",
                  link: "",
                },
              ],
            },
            {
              id: 24,
              title: "Exact Sciences",
              link: "",
              children: [
                {
                  id: 12,
                  title: "Math",
                  link: "",
                },
                {
                  id: 13,
                  title: "Physics",
                  link: "",
                },
              ],
            },
            {
              id: 25,
              title: "Foreign languages",
              link: "",
              children: [
                {
                  id: 14,
                  title: "General English",
                  link: "",
                },
              ],
            },
          ],
        },
        {
          id: 2,
          title: "Fanlar",
          link: "/subjects",
          submenu: false,
          children: [
            {
              id: 20,
              title: "Web development",
              link: "",
              children: [
                {
                  id: 7,
                  title: "Vue JS 3",
                  link: "",
                  classMenu: false,
                },
                {
                  id: 8,
                  title: "React",
                  link: "",
                  classMenu: false,
                },
              ],
            },
          ],
        },
      ],
      search: "",
      navigationDrawer: false,
      showDropdown: false,
      accountDropdown: false,
      languageDropdown: false,
    };
  },
  props: {
    headerShadow: {
      type: Boolean,
      default: false,
    },
    headerGreyBg: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters([
      "isLoggedOn",
      "skillTree",
      "subjectTree",
      "user",
      "coursesOnBasket",
      "favouriteCourses",
    ]),
  },
  methods: {
    closeDrawer() {
      this.navigationDrawer = false;
    },
    ...mapMutations(["setAccessToken", "setIsLoggedOn"]),
    ...mapActions([
      "getSkillTree",
      "getSubjectTree",
      "getUser",
      "getCoursesInBasket",
      "getFavouriteCourses",
      "getBoughtCourses",
    ]),
    showNavigationDrawer() {
      this.navigationDrawer = !this.navigationDrawer;
    },
    hideAccountDropdown() {
      this.accountDropdown = false;
    },
    hideLanguageDropdown() {
      this.languageDropdown = false;
    },
    handleShowDropdown(id) {
      if (this.isMobile) {
        return {
          click: () => (this.activeId = this.activeId === id ? null : id),
        };
      }
      return {
        click: () => (this.activeId = this.activeId === id ? null : id),
        mouseenter: () => (this.activeId = id),
        mouseleave: () => (this.activeId = null),
      };
    },
    handleShowDropdownInner(id) {
      if (this.isMobile) {
        return {
          click: () => (this.subActiveId = this.subActiveId === id ? null : id),
        };
      }
      return {
        click: () => (this.subActiveId = this.subActiveId === id ? null : id),
        mouseenter: () => (this.subActiveId = id),
        mouseleave: () => (this.subActiveId = null),
      };
    },
    prepareSkillCourseTree(data, menu) {
      data.forEach((d) => {
        let parentMenuModel = {
          id: d.id,
          title: d.name,
          link: "",
          children: [],
        };
        let childrenMenus = [];
        if (d.courseList) {
          d.courseList.forEach((children) => {
            let childrenMenuModel = {
              id: children.id,
              title: children.name,
              link: "",
            };
            childrenMenus.push(childrenMenuModel);
          });
          parentMenuModel.children = childrenMenus;
        }
        menu.push(parentMenuModel);
      });
    },
    logout() {
      this.$api
        .delete(
          "auth/Login/logout?refreshtoken=" + TokenService.getRefreshToken()
        )
        .then((data) => {
          if (data.statusCode === 200) {
            TokenService.removeToken();
            TokenService.removeRefreshToken();
            localStorage.clear();
            this.setToken();
          }
        })
        .catch((error) => {
          console.log(error, " error");
        });
    },
    setToken() {
      this.setAccessToken(null);
      this.setIsLoggedOn(false);
    },
  },
  async mounted() {
    if (this.userIsLoggedOn) {
      await this.getUser();
    }
    await this.getSkillTree();
    await this.getSubjectTree();
    await this.getCoursesInBasket();
    await this.getFavouriteCourses();
    await this.getBoughtCourses();
    this.menu[0].children = [];
    this.prepareSkillCourseTree(this.skillTree, this.menu[0].children);
    this.menu[1].children = [];
    this.prepareSkillCourseTree(this.subjectTree, this.menu[1].children);
  },
  watch: {
    skillTree() {
      this.menu[0].children = [];
      this.prepareSkillCourseTree(this.skillTree, this.menu[0].children);
    },
    subjectTree() {
      this.menu[1].children = [];
      this.prepareSkillCourseTree(this.subjectTree, this.menu[1].children);
    },
    async isLoggedOn() {
      if (this.userIsLoggedOn) {
        await this.getUser();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active до версии 2.1.8 */
 {
  opacity: 0;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: #ffffff96;
  z-index: 49;
}
</style>
